import { render, staticRenderFns } from "./HolderEdit.vue?vue&type=template&id=510afc23&scoped=true&"
import script from "./HolderEdit.vue?vue&type=script&lang=ts&"
export * from "./HolderEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510afc23",
  null
  
)

export default component.exports